var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2493 11.986C32.2181 5.82822 26.4899 1.69853 19.9727 1.6329C18.9681 1.75478 17.9415 1.78916 16.9634 2.01728C10.7931 3.47822 6.76649 7.29384 5.40087 13.4626C4.03525 19.6313 6.08993 24.8048 11.0712 28.7188C13.7274 30.8017 15.979 33.2079 17.7024 36.1079C17.9962 36.5985 18.2712 37.1032 18.5962 37.572C19.329 38.6282 20.6759 38.636 21.4087 37.572C21.779 37.0392 22.1009 36.4782 22.4196 35.9063C24.0477 33.0282 26.2321 30.6751 28.9056 28.7188C31.4545 26.8559 33.3456 24.2313 34.306 21.2238C35.2665 18.2164 35.2466 14.9815 34.2493 11.986Z",
    fill: "url(#paint0_linear_106_1185)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3077 16.2308L14.2308 15.0769C15.4154 14.3692 16.8924 14.3692 18.077 15.0769C19.2616 15.7846 20.7385 15.7846 21.9231 15.0769C23.1077 14.3692 24.5847 14.3692 25.7693 15.0769L27.6924 16.2308",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3077 9.15384L14.2308 10.3077C15.4154 11.0154 16.8924 11.0154 18.077 10.3077C19.2616 9.59999 20.7385 9.59999 21.9231 10.3077C23.1077 11.0154 24.5847 11.0154 25.7693 10.3077L27.6924 9.15384",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3077 21.6154L14.2308 20.4615C15.4154 19.7538 16.8924 19.7538 18.077 20.4615C19.2616 21.1692 20.7385 21.1692 21.9231 20.4615C23.1077 19.7538 24.5847 19.7538 25.7693 20.4615L27.6924 21.6154",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_1185",
    x1: 4.99149,
    y1: 1.00478,
    x2: 29.8352,
    y2: 29.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F80ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.541d927333af3366f8ecd31dd94d2d65.svg";
export { ForwardRef as ReactComponent };